import React, { useState, useEffect } from 'react';
import { Footer, Header } from "./headerFooter";
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { useNavigate, Link } from 'react-router-dom';
import { EDU_SPECIALTIES } from './constants';
import { getHost } from './config';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./custom.scss";


const Register = () => {
  // State to handle input values
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [specialty, setSpecialty] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [touched, setTouched] = useState({ username: false, password: false });
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    table_value: '', // or "specialty" if you rename it
  
  });

  const usernameIsValid =
    username.length >= 6 &&
    username.length <= 20 &&
    /[a-zA-Z]/.test(username); // at least one letter

  const passwordIsValid =
    password.length >= 6 &&
    password.length <= 20 &&
    /[a-zA-Z]/.test(password) && // at least one letter
    /\d/.test(password);        // at least one number

  
  // Function to handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      // Call the /register endpoint with the attributes needed
      const url = `${getHost()}/api/register`
      console.log(`Attempting to call: ${url}`); // Debugging URL
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password,
          email,
          specialty,
          acceptedTerms
        }),
      });

      const data = await response.json();

      // Check if the response is OK
      if (response.ok) {
        setSuccess(data.message || "Επιτυχής εγγραφή");
        setError('');

        if (window.gtag) {
          const reversedUsername = username.split('').reverse().join('');
          window.gtag('set', {'user_id': reversedUsername});
          window.gtag('event', 'register_user', {
            specialty: specialty,
          });
        }
      } else {
        setError(data.message || "Προσπαθήστε ξανά");
        setSuccess('');
      }

    } catch (error) {
      // Handle errors (e.g., wrong credentials)
      setError('Register failed, please try again');
      setSuccess('');
    }
  };

  const handleCheckboxChange = (e) => {
    setAcceptedTerms(e.target.checked);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const isFormValid = username !== '' && password !== '' && email !== '' && specialty !== '' && acceptedTerms;
  
  return (
    <div id="root">
      <Header />
      <main className='center-container'>
        <Container className='custom-container p-3'>
          {error && <Alert className='alert-error'>
              {error}
            </Alert>}

          {/* Success message */}
          {success ? (
            <div className="result">
             <Alert className="alert-success">{success}</Alert>
             <Button onClick={() => navigate('/')} variant="danger">Επιστροφή στην οθόνη εισόδου</Button>
            </div>
          ) : (
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="registerForm.username">
                <Form.Label className="custom-label">Όνομα χρήστη:</Form.Label>
                <Form.Control 
                  className="custom-form"
                  value={username} 
                  onChange={(e) => setUsername(e.target.value.trimEnd())}
                  onBlur={() => setTouched(prev => ({ ...prev, username: true }))}
                  isInvalid={touched.username && !usernameIsValid}
                  required/>
                <Form.Control.Feedback type="invalid">
                  Το όνομα χρήστη πρέπει να έχει 6–20 χαρακτήρες και τουλάχιστον ένα γράμμα.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="registerForm.password">
                <div className="d-flex align-items-center gap-2">
                  <Form.Label className="custom-label">Κωδικός πρόσβασης</Form.Label>
                  <span
                      style={{ cursor: 'pointer', color: '#6c757d' }}
                      className="mb-2"
                      onClick={() => setShowPassword(prev => !prev)}
                  >
                      {showPassword ? (
                          <i className="bi bi-eye-slash"></i>
                      ) : (
                          <i className="bi bi-eye"></i>
                      )}
                  </span>
                </div>
                <Form.Control
                  className="custom-form pe-5" // Add padding for the icon
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value.trimEnd())}
                  onBlur={() => setTouched(prev => ({ ...prev, password: true }))}
                  isInvalid={touched.password && !passwordIsValid}
                  required
                />

                
                <Form.Control.Feedback type="invalid">
                Ο κωδικός πρέπει να έχει 6–20 χαρακτήρες, ένα γράμμα και έναν αριθμό.
                </Form.Control.Feedback>
                
              </Form.Group>
              <Form.Group className="mb-3" controlId="registerForm.email">
                <Form.Label className="custom-label">e-mail</Form.Label>
                <Form.Control className="custom-form" type="email" value={email} onChange={(e) => setEmail(e.target.value.trimEnd())} required/>
              </Form.Group>
              <Form.Group className="mb-3" controlId="registerForm.specialty">
                <Form.Label className='custom-label'>Ειδικότητα</Form.Label>
                <Form.Select className="custom-form" name="specialty" value={specialty} onChange={(e) => setSpecialty(e.target.value)} required>
                    <option value="">Επιλέξτε ειδικότητα</option>
                    {EDU_SPECIALTIES.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option> ))}
                </Form.Select>
              </Form.Group>
              <div>
                <Form.Check
                  inline
                  label={
                    <>
                      Έχω διαβάσει και αποδέχομαι τους{' '}
                      <Link to="/terms-of-use" target="_blank" rel="noopener noreferrer" className="footer-links">
                        όρους χρήσης
                      </Link>.
                    </>
                  }
                  name="group1"
                  type="checkbox"
                  id="inline-checkbox-1"
                  className="pb-2 custom-label"
                  checked={acceptedTerms}
                  onChange={handleCheckboxChange}
                />
              </div>
              <Button variant="danger" type="submit" disabled={!isFormValid}>Ολοκλήρωση εγγραφής</Button>
            </Form>
          )}
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export default Register;